// @flow
import {
  UPDATE_NOTIFICATION,
  UPDATE_NOTIFICATION_SUCCESS,
  SET_NOTIFICATIONS,
  RESTORE_SEARCH_NOTIFICATIONS,
  DELETE_SEARCH_NOTIFICATION_SUCCESS,
  DELETE_SEARCH_NOTIFICATION_ERROR,
  DISABLE_NOTIFICATION,
  DISABLE_NOTIFICATION_SUCCESS,
  SET_NOTIFICATION_WEEKLY_FREQUENCY,
  SET_NOTIFICATION_WEEKLY_FREQUENCY_SUCCESS,
} from './actionTypes';
import type { SearchNotification } from '../types';

export function setSearchNotifications(notifications: Array<SearchNotification<*>>) {
  return {
    type: SET_NOTIFICATIONS,
    payload: notifications,
  };
}

export function updateNotification(
  notification: SearchNotification<*>,
  changes: $Shape<SearchNotification<*>>
): TrovitAction {
  return {
    type: UPDATE_NOTIFICATION,
    payload: {
      notification,
      changes,
    },
  };
}

export function updateNotificationSuccess(notification: SearchNotification<*>): TrovitAction {
  return {
    type: UPDATE_NOTIFICATION_SUCCESS,
    payload: notification,
  };
}

export function restoreSearchNotifications(
  notifications: Array<SearchNotification<*>>
): TrovitAction {
  return {
    type: RESTORE_SEARCH_NOTIFICATIONS,
    payload: notifications,
  };
}

export function deleteSearchNotificationSuccess(notification: SearchNotification<*>): TrovitAction {
  return {
    type: DELETE_SEARCH_NOTIFICATION_SUCCESS,
    payload: notification,
  };
}

export function deleteSearchNotificationError(
  notifications: Array<SearchNotification<*>>
): TrovitAction {
  return {
    type: DELETE_SEARCH_NOTIFICATION_ERROR,
    payload: notifications,
  };
}

export function disableNotification(): TrovitAction {
  return {
    type: DISABLE_NOTIFICATION,
  };
}

export function disableNotificationSuccess(notification: SearchNotification<*>): TrovitAction {
  return {
    type: DISABLE_NOTIFICATION_SUCCESS,
    payload: notification,
  };
}

export function setNotificationWeeklyFrequency(): TrovitAction {
  return {
    type: SET_NOTIFICATION_WEEKLY_FREQUENCY,
  };
}

export function setNotificationWeeklyFrequencySuccess(
  notification: SearchNotification<*>
): TrovitAction {
  return {
    type: SET_NOTIFICATION_WEEKLY_FREQUENCY_SUCCESS,
    payload: notification,
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/SearchNotifications/actions.js